import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';
import {Injectable} from '@angular/core';
import {Observable, OperatorFunction} from 'rxjs';
import {map} from 'rxjs/operators';

export enum MediaScreenSize {
  small = '(max-width: 599.98px)',
  medium = '(min-width: 600px) and (max-width: 1023.98px)',
  large = '(min-width: 1024px)',
}

function selectMatches(): OperatorFunction<BreakpointState, boolean> {
  return map(state => state.matches);
}

@Injectable({
  providedIn: 'root',
})
export class BreakpointUtilityService {
  smallScreen$: Observable<boolean>;
  mediumScreen$: Observable<boolean>;
  largeScreen$: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.smallScreen$ = this.breakpointObserver
      .observe(MediaScreenSize.small)
      .pipe(selectMatches());

    this.mediumScreen$ = this.breakpointObserver
      .observe(MediaScreenSize.medium)
      .pipe(selectMatches());

    this.largeScreen$ = this.breakpointObserver
      .observe(MediaScreenSize.large)
      .pipe(selectMatches());
  }
}
